import React from 'react';

import { Grid, Row, Column } from '@xingternal/malt-grid';

import NoScriptFallback from './../NoScriptFallback/NoScriptFallback';
import GdprImage from './../Illustrations/GdprImage';
import Spacer from './../Spacer/Spacer';

const GridWrapper = React.memo(
  ({ wide = false, children, noJavascriptFallback }) => (
    <Grid outermost>
      <Row outermost>
        <Column
          size={12}
          offset={0}
          sizeTablet={8}
          offsetTablet={2}
          sizeDesktop={wide ? 12 : 4}
          offsetDesktop={wide ? 0 : 4}
        >
          <NoScriptFallback noFallback={noJavascriptFallback}>
            {children}
            <GdprImage />
            <Spacer size={32} media={'tablet'} />
          </NoScriptFallback>
        </Column>
      </Row>
    </Grid>
  )
);

export default GridWrapper;
